<template>
  <span class="o-loader" :class="{ 'is-firstload': isFirstLoad }" ref="loader">
    <span class="o-loader__header" ref="loaderHeader"></span>
    <span class="o-loader__main" ref="loaderMain">
      <loader-logo v-if="isFirstLoad" />
    </span>
  </span>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "src/event-bus.js";

import Variables from "src/mixins/variables";

import gsap from "gsap";

import LoaderLogo from "components/Loader/LoaderLogo";

export default {
  name: "Loader",
  mixins: [Variables],
  components: {
    LoaderLogo
  },
  computed: {
    ...mapState({
      isFirstLoad: state => state.global.isFirstLoad
    })
  },
  data: () => ({
    color: {
      light: "#f7cad1",
      dark: "#f6dadf"
    }
  }),
  mounted() {
    // Loader out
    let styles = getComputedStyle(this.$el);
    this.color.light = styles.getPropertyValue("--bg-light");
    this.color.dark = styles.getPropertyValue("--bg-dark");

    this.color.light = "rgba(247, 202, 209, 1)";
    this.color.dark = "rgba(246, 218, 223, 1)";

    this.animateHeaderOut();
    this.animateMainOut(this.animationOutDelay());

    EventBus.$on("loader-cover-all", next => {
      this.animateHeaderIn();
      this.animateMainIn(next, false);
    });
  },
  methods: {
    animationOutDelay() {
      return this.isFirstLoad ? 2.5 : 1.3;
    },
    animateHeaderIn() {
      gsap.to(this.$refs.loaderHeader, {
        duration: 0.8,
        scaleX: 1,
        scaleY: 1,
        ease: "power2.in"
      });
    },
    animateHeaderOut(delay = 0) {
      gsap.to(this.$refs.loaderHeader, {
        duration: 0.8,
        scaleX: this.ifHorizontal(0, 1),
        scaleY: this.ifHorizontal(1, 0),
        delay: delay,
        ease: "power2.inOut"
      });
    },
    animateMainIn(next, proceed = true) {
      gsap.set(this.$refs.loaderMain, {
        scaleX: this.ifHorizontal(0, 1),
        scaleY: this.ifHorizontal(1, 0),
        backgroundColor: this.color.dark
      });
      gsap.to(this.$refs.loaderMain, {
        duration: 1,
        scaleX: 1,
        scaleY: 1,
        ease: "power3.in",
        onComplete: () => {
          const testTimeout = setTimeout(() => {
            next();

            if (proceed) {
              EventBus.$emit("loader-cover");

              this.animateMainOut();
            }
            clearTimeout(testTimeout);
          }, 10);
        }
      });
    },
    animateMainOut(delay = 0) {
      let $intro = this.$parent.$refs.main.querySelector(".l-section__intro");

      let size = {
        x: $intro ? $intro.offsetWidth : this.W.w,
        y: $intro ? $intro.offsetHeight : this.W.h
      };

      gsap.to(this.$refs.loaderMain, {
        duration: 0.6,
        x: this.ifHorizontal(size.x, 0),
        y: this.ifHorizontal(0, size.y),
        delay: delay,
        backgroundColor: this.color.light,
        autoAlpha: 1,
        ease: "power3.inOut",
        onComplete: () => {
          this.$store.commit("global/toggleFirstLoad", false);
          gsap.set(this.$refs.loaderMain, { scale: 0, x: 0, y: 0 });
          EventBus.$emit("loader-complete");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.o-loader {
  --bg-light: #{$color-light};
  --bg-dark: #{$color-lighter};

  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .is-loading & {
    pointer-events: initial;
  }

  &.is-firstload {
    .o-loader__main {
      transform: scale(1);
      transform-origin: 50% 0;
    }
  }

  @media #{$breakpoint-vertical} {
    &.is-firstload {
      .o-loader__main {
        transform-origin: 50% 100%;
      }
    }
  }

  @media #{$breakpoint-horizontal} {
    &.is-firstload {
      .o-loader__main {
        transform-origin: 100% 50%;
      }
    }
  }
}

.o-loader__main,
.o-loader__header {
  position: absolute;
  display: block;
  background-color: $color-bright;
  will-change: transform;
}

.o-loader__main {
  @media #{$breakpoint-vertical} {
    /* top: var(--header-size); */
    left: 0;
    width: 100%;
    /* height: calc(#{vh(100)} - var(--header-size)); */
    height: 100vh;
    top: 0;
    transform-origin: 50% 0;
  }

  @media #{$breakpoint-horizontal} {
    top: 0;
    left: 0;
    /* left: var(--header-size);
        width: calc(100% - var(--header-size)); */
    width: 100%;
    height: 100%;
    transform-origin: 0 50%;
  }
}

/* * body {
  .is-firstload & {
    background-color: $color-lighter;
  }
} */

.o-loader__header {
  top: 0;
  left: 0;
  opacity: 0;

  @media #{$breakpoint-vertical} {
    width: 100%;
    height: var(--header-size);
    transform-origin: 50% 100%;
  }

  @media #{$breakpoint-horizontal} {
    width: var(--header-size);
    height: 100%;
    transform-origin: 100% 50%;
  }
}
</style>
